import { Box } from '@material-ui/core';
import { Currency } from '@nemuru-eng/js-api-client';

import { useAutoDetails } from '@/components/modules/Application/components/Cart/AutoCart/hooks/useAutoDetails';
import { AutomobileForm } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/components/AutomobileForm';
import { VehicleAmountField } from '@/components/modules/Application/components/Cart/DefaultCart/components/ArticleTypes/Automobile/components/VehicleAmountField';
import { LoadingValues } from '@/components/shared/components/LoadingValues/LoadingValues';

interface AutoDetailsFormWrapperProps {
  loading: boolean;
}

export const AutoDetailsFormWrapper = ({ loading }: AutoDetailsFormWrapperProps) => {
  const { cart } = useAutoDetails();

  if (loading) {
    return (
      <Box
        height={'391px'}
        width={'100%'}
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
      >
        <LoadingValues titleTextId={'LOADING_AUTO_DETAILS'} />
      </Box>
    );
  }

  return (
    <Box display="flex" flexDirection="column" gridGap={32}>
      <AutomobileForm />
      <VehicleAmountField currency={cart?.currency ?? Currency.EUR} />
    </Box>
  );
};
